export const FORMATS = [
  { value: "largometraje", label: "Largometraje" },
  { value: "cortometraje", label: "Cortometraje" },
  { value: "serie", label: "Serie" },
  { value: "miniserie", label: "Miniserie" },
  { value: "documental", label: "Documental" },
  { value: "programa", label: "Programa de TV" },
  { value: "videoclip", label: "Videoclip" },
  { value: "podcast", label: "Pódcast audiovisual" },
  { value: "streaming", label: "Streaming" },
  { value: "digital", label: "Contenido digital" },
  { value: "branded", label: "Branded content" },
  { value: "otro", label: "Otro" },
];

export const GENRES = [
  "drama", "comedia", "acción", "thriller", "romance",
  "documental", "coming-of-age", "ciencia ficción", "terror",
  "fantasía", "musical", "biopic", "familiar", "infantil",
];

export const STAGES = [
  { value: "idea", label: "Idea" },
  { value: "development", label: "Desarrollo" },
  { value: "script", label: "Guion" },
  { value: "preproduction", label: "Preproducción" },
  { value: "shooting", label: "Rodaje" },
  { value: "postproduction", label: "Posproducción" },
  { value: "distribution", label: "Distribución" },
  { value: "finished", label: "Terminado" },
];

export const COUNTRIES = [
  "Chile", "Argentina", "México", "Colombia", "Perú", "Brasil",
  "España", "Estados Unidos", "Uruguay", "Ecuador", "Venezuela",
  "Bolivia", "Paraguay", "Costa Rica", "Panamá", "Guatemala",
];

export const INDUSTRIES = [
  "automotriz", "tecnología", "moda", "consumo", "alimentos",
  "bebidas", "telecomunicaciones", "finanzas", "salud",
  "sostenibilidad", "turismo", "energía", "educación",
  "streaming", "gaming", "movilidad", "cultura", "hogar",
];

export const CONTRIBUTION_TYPES = [
  { value: "placement", label: "Placement" },
  { value: "sponsorship", label: "Auspicios y engagement" },
  { value: "donation", label: "Donación cultural" },
  { value: "products", label: "Aporte en productos" },
  { value: "services", label: "Aporte en servicios" },
  { value: "coproduction", label: "Coproducción" },
];

export const PLACEMENT_TYPES = [
  { value: "passive", label: "Pasivo" },
  { value: "active", label: "Activo" },
  { value: "verbal", label: "Verbal" },
  { value: "narrative", label: "Narrativo" },
  { value: "virtual", label: "Virtual / digital" },
];

export const OBJECTIVES = [
  "reconocimiento", "lanzamiento", "reposicionamiento",
  "nueva audiencia", "generar ventas", "consideración",
  "reputación", "responsabilidad social", "sostenibilidad",
  "impacto cultural", "diversidad", "beneficio tributario",
];

export const KPIS = [
  "alcance", "visualizaciones", "impresiones", "interacciones",
  "menciones", "ugc", "tráfico", "registros", "ventas",
  "valor de exposición", "asistentes", "cobertura de prensa",
];

export const VALUES_LIST = [
  "sostenibilidad", "diversidad", "cultura", "innovación",
  "autenticidad", "creatividad", "impacto social", "impacto ambiental",
  "familia", "libertad", "identidad", "comunidad", "educación",
];

export const INTERESTS = [
  "cine independiente", "viajes", "cultura", "sostenibilidad",
  "música", "moda", "gaming", "streaming", "tecnología",
  "gastronomía", "deportes", "documentales", "naturaleza", "ciencia",
  "medio ambiente", "outdoor",
];
